import { Injectable } from '@angular/core'
import { Browser, IBrowserInformation, IBrowserVersion } from '@components/exportable/browser-upgrade-notice/interfaces/i-browser-information.interface'
import { browserDownloadList, supportedBrowserVersions } from '@components/exportable/browser-upgrade-notice/data/supported-browser-list'

@Injectable({
  providedIn: 'root',
})
export class BrowserUpgradeNoticeService {
  detectBrowser(userAgent: string): IBrowserInformation {
    // Chromium based browsers must come before Chrome
    switch (true) {
      case userAgent.includes(Browser.EDGE.userAgentLookup):
        return this.createBrowserInformation(Browser.EDGE, this.extractVersion(userAgent.split(Browser.EDGE.userAgentLookup)[1]))
      case userAgent.includes(Browser.CHROME.userAgentLookup):
        return this.createBrowserInformation(Browser.CHROME, this.extractVersion(userAgent.split(Browser.CHROME.userAgentLookup)[1]))
      case userAgent.includes(Browser.FIREFOX.userAgentLookup):
        return this.createBrowserInformation(Browser.FIREFOX, this.extractVersion(userAgent.split(Browser.FIREFOX.userAgentLookup)[1]))
      case userAgent.includes(Browser.SAFARI.userAgentLookup):
        const versionParts: string[] = userAgent.split('Version/')
        return this.createBrowserInformation(Browser.SAFARI, this.extractVersion(versionParts[versionParts.length - 1])) // In edge case where multiple versions are within user agent, always take the last version
      default:
        return this.createBrowserInformation(Browser.UNKNOWN, { major: 0, minor: 0 })
    }
  }

  validateBrowser(browser: IBrowserInformation): boolean {
    if (!Object.keys(supportedBrowserVersions).includes(browser.title.userAgentLookup)) return false
    if (browser.version.major < supportedBrowserVersions[browser.title.userAgentLookup].major) return false
    return true
  }

  private createBrowserInformation(browser: Browser, version: IBrowserVersion): IBrowserInformation {
    return { title: browser, version, download: browserDownloadList[browser.userAgentLookup] }
  }

  private extractVersion(version: string): IBrowserVersion {
    const versions: string[] = version?.split('.')
    return { major: +versions[0], minor: +versions[1] }
  }
}
